import type { ProductSelectionType, Values } from '../AppsTwitch.types'

export const getProductSelection = (
  type: Values['productSelectionType'],
  excludedOfferIds: Values['excludedProductsIds'],
  includedOfferIds: Values['includedProductsIds'],
): ProductSelectionType => {
  if (type === 'SELECTED_PRODUCTS') {
    return {
      type,
      offerIds: includedOfferIds,
    }
  }

  if (type === 'ALL_PRODUCTS' && !!excludedOfferIds.length) {
    return {
      type: 'EXCLUDED_PRODUCTS',
      offerIds: excludedOfferIds,
    }
  }

  return { type }
}
